import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const current_path = state.url
    let currentUserRole = localStorage.getItem("role");
    let features = JSON.parse(localStorage.getItem('featuresList'))
    if(features){
      let currentMainPath = state.url.split('/')[1];
      let currentSubPath =  state.url.split('/')[2]
      let mainFeature = features.find(sub => sub.url.split('/')[1] == currentMainPath)
      if(!mainFeature){
        localStorage.setItem('readOnly', 'false')
        return true
      }
      if(mainFeature.allowedRoles.includes(currentUserRole)){
        let SubFeture = mainFeature.subFeatures.find((fet)=>{
          let path = fet.path.split('/')[2]
          if(path == currentSubPath){
            return fet
          }
        })
        if(SubFeture){
          if(SubFeture.allowedFullAccess.includes(currentUserRole)){
            localStorage.setItem('readOnly', 'false')
            return true
          }
          else if(SubFeture.allowedReadAccess.includes(currentUserRole)){
            localStorage.setItem('readOnly', 'true')
            return true
          }
          else {
            this.router.navigateByUrl("/unauthorized")
            localStorage.setItem('readOnly', 'false')
            return false;
          }
        }
        else{
          localStorage.setItem('readOnly', 'false')
          return true

        }
      }
      else {
        this.router.navigateByUrl("/unauthorized")
        return false;
  
      }
    }
    else{
      this.router.navigateByUrl("/login")
    }
    // let allowedRoles = next.data.allowedRoles;
    // return true;
    
    // if (allowedRoles == null || allowedRoles.length === 0) {
    // } 

    // if (allowedRoles.includes(Number(currentUserRole))) {
    //   return true;
    // }

    return true;

  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

}
